import React from 'react';
import { IRowButtonProps } from './IRowButtonProps';

const RowButton: React.FC<IRowButtonProps> = (props) => {
  return (
    <button
      type={props.type}
      form={props.form}
      className={props.className + style.button}
    >
      {props.title}
    </button>
  );
};

const style = {
  button: ' w-full text-lg py-6 bottom-0 font-medium',
};

export default RowButton;
